export default __webpack_public_path__ + "static/media/evil.069c55da.png";